import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  credentialID: string,
  teamName: string,
  displayName: string,
  urls: arrayOf(string),
  identifier: string,
  secret: string,
  appName: string
});



// WEBPACK FOOTER //
// ./js/types/api/credential.js